import { PulsarButton } from '@pulsarml/ui.react.components';
import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

interface ActionButtonsRowProps {
  confirmText: React.ReactNode;
  cancelText: React.ReactNode;
  className?: string;
  isDisabled: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

function ActionButtonsRow(props: ActionButtonsRowProps) {
  return (
    <div className={cn(styles['menu-action-buttons'], props.className)}>
      <PulsarButton
        size="large"
        variant="solid"
        colorSet="primary"
        className={styles['menu-action-button']}
        onClick={props.onConfirm}
        disabled={props.isDisabled}
      >
        {props.confirmText}
      </PulsarButton>
      <PulsarButton
        className={`${styles['cancel-button']} ${styles['menu-action-button']}`}
        size="large"
        variant="outline"
        colorSet="secondary"
        onClick={props.onCancel}
      >
        {props.cancelText}
      </PulsarButton>
    </div>
  );
}

export default ActionButtonsRow;
